// src/pages/Browser/BrowserPage.js
import React, { useEffect } from 'react';
import Browser from './Browser';

const BrowserPage = () => {
  // Set document title
  useEffect(() => {
    document.title = 'BitDog Wallet | Browser';
    
    // Set a max width for mobile view
    const setViewportProperties = () => {
      const viewport = document.querySelector('meta[name=viewport]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
      }
    };
    
    setViewportProperties();
    
    return () => {
      // Restore original viewport settings
      const viewport = document.querySelector('meta[name=viewport]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
      }
    };
  }, []);

  return (
    <div className="browser-page">
      <Browser />
    </div>
  );
};

export default BrowserPage;